import "../Styles/skills.css";
import { skills } from "../utils/Skills";



export const Skills = () => {
  return (
    <div className="skills" id="skills">
      <p className="header">Skills</p>
      <div className="skills-content">
        {skills.map((el) => {
          return (
            <div className="icons">
              <img className="icon-img" src={el[0]} alt="" />
              <div className="icon-title">{el[1]}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
